import { useOverlays } from "contexts/OverlayContext";
import { PlainModal } from "@design-system/Modal/Modal";
import { ConfigureOrganizationPermissionsModal } from "./ConfigureOrganizationPermissionsModal";

export const ConfigureOrganizationPermissionsModalOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo(
        "organizationConfigureMemberPermissions",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <PlainModal show={!overlayIsClosing} onHide={closeOverlay}>
            <ConfigureOrganizationPermissionsModal
                member={overlayInfo.data.member}
                organization={overlayInfo.data.organization}
                closeModal={closeOverlay}
            />
        </PlainModal>
    );
};
